<template>
  <div>
    <form method="get" action="/" class="form-horizontal">
      <vue-tabs class="row" direction="vertical" value="Description">
        <v-tab title="Server" v-if="isGroupEnabled('Server')">
          <field-set :row-fields="['server.threads']">
            <template v-slot:default="slotProps">
              <div v-if="isSettingEnabled(slotProps.rowFields)">
                <label class="col-sm-2 control-label">Parallel processes</label>
                <div class="col-sm-8 text-left">
                  <el-slider class="slider-success" v-model="settings['server.threads']" :min="1" :max="1000" :disabled="!isSettingSet(slotProps.rowFields)"/>
                  <span class="help-block">How many parallel grab processes should be run on a grab server by default.</span>
                </div>
                <div class="col-sm-2 control-label">
                  <p-checkbox @input="toggleSetOptions(slotProps.rowFields)" :checked="!isSettingSet(slotProps.rowFields)">{{ useDefaultLabel }}</p-checkbox>
                </div>
              </div>
            </template>
          </field-set>

          <field-set :row-fields="['server.periodicity.minute', 'server.periodicity.hour', 'server.periodicity.day', 'server.periodicity.month', 'server.periodicity.day_week']">
            <template v-slot:default="slotProps">
              <div v-if="isSettingEnabled(slotProps.rowFields)">
                <label class="col-sm-2 control-label">Grab job periodicity</label>
                <div class="col-sm-8 text-left">
                  <div class="row">
                    <div class="col-md-2">
                      <input type="text" placeholder="Minute" class="form-control" v-model="settings['server.periodicity.minute']" :disabled="!isSettingSet(slotProps.rowFields)">
                    </div>
                    <div class="col-md-2">
                      <input type="text" placeholder="Hour" class="form-control" v-model="settings['server.periodicity.hour']" :disabled="!isSettingSet(slotProps.rowFields)">
                    </div>
                    <div class="col-md-2">
                      <input type="text" placeholder="Day" class="form-control" v-model="settings['server.periodicity.day']" :disabled="!isSettingSet(slotProps.rowFields)">
                    </div>
                    <div class="col-md-2">
                      <input type="text" placeholder="Month" class="form-control" v-model="settings['server.periodicity.month']" :disabled="!isSettingSet(slotProps.rowFields)">
                    </div>
                    <div class="col-md-2">
                      <input type="text" placeholder="Day of the Week" class="form-control" v-model="settings['server.periodicity.day_week']" :disabled="!isSettingSet(slotProps.rowFields)">
                    </div>
                  </div>
                  <span class="help-block">Standard cron job syntax.</span>
                </div>
                <div class="col-sm-2 control-label">
                  <p-checkbox @input="toggleSetOptions(slotProps.rowFields)" :checked="!isSettingSet(slotProps.rowFields)">{{ useDefaultLabel }}</p-checkbox>
                </div>
              </div>
            </template>
          </field-set>

          <field-set :row-fields="['server.refresh_rate']">
            <template v-slot:default="slotProps">

              <div v-if="isSettingEnabled(slotProps.rowFields)">
                <label class="col-sm-2 control-label">Grab data refresh rate</label>
                <div class="col-sm-8 text-left">
                  <input type="text" placeholder="Minutes" class="form-control" v-model="settings['server.refresh_rate']" :disabled="!isSettingSet(slotProps.rowFields)">
                  <span class="help-block">How often should data in grab console be updated during grabbing process (minutes).</span>
                </div>
                <div class="col-sm-2 control-label">
                  <p-checkbox @input="toggleSetOptions(slotProps.rowFields)" :checked="!isSettingSet(slotProps.rowFields)">{{ useDefaultLabel }}</p-checkbox>
                </div>
              </div>
            </template>
          </field-set>

          <field-set :row-fields="['server.timeout']">
            <template v-slot:default="slotProps">

              <div v-if="isSettingEnabled(slotProps.rowFields)">
                <label class="col-sm-2 control-label">Grab command timeout</label>
                <div class="col-sm-8 text-left">
                  <input type="text" placeholder="Minutes" class="form-control" v-model="settings['server.timeout']" :disabled="!isSettingSet(slotProps.rowFields)">
                  <span class="help-block">Maximum amount of time grab command is allowed to run in minutes.</span>
                </div>
                <div class="col-sm-2 control-label">
                  <p-checkbox @input="toggleSetOptions(slotProps.rowFields)" :checked="!isSettingSet(slotProps.rowFields)">{{ useDefaultLabel }}</p-checkbox>
                </div>
              </div>
            </template>
          </field-set>
        </v-tab>

        <v-tab title="WebGrab+" v-if="isGroupEnabled('WebGrab')">
          <field-set :row-fields="['webgrab.postprocessing']">
            <template v-slot:default="slotProps">
              <div v-if="isSettingEnabled(slotProps.rowFields)">
                <label class="col-sm-2 control-label">Enabled postprocessing</label>
                <div class="col-sm-8 text-left">
                  <p-radio label="mdb" v-model="settings['webgrab.postprocessing']" :disabled="!isSettingSet(slotProps.rowFields)">mdb</p-radio>
                  <p-radio label="rex" v-model="settings['webgrab.postprocessing']" :disabled="!isSettingSet(slotProps.rowFields)">rex</p-radio>
                  <p-radio label="0" v-model="settings['webgrab.postprocessing']" :disabled="!isSettingSet(slotProps.rowFields)">none</p-radio>
                </div>
                <div class="col-sm-2 control-label">
                  <p-checkbox @input="toggleSetOptions(slotProps.rowFields)" :checked="!isSettingSet(slotProps.rowFields)">{{ useDefaultLabel }}</p-checkbox>
                </div>
              </div>
            </template>
          </field-set>

          <field-set :row-fields="['proxy.server', 'proxy.port']">
            <template v-slot:default="slotProps">

              <div v-if="isSettingEnabled(slotProps.rowFields)">
                <label class="col-sm-2 control-label">Proxy server</label>
                <div class="col-sm-3 text-left">
                  <input type="text" placeholder="Host" class="form-control" v-model="settings['proxy.server']" :disabled="!isSettingSet(slotProps.rowFields)">
                </div>
                <div class="col-sm-2 text-left">
                  <input type="text" placeholder="Port" class="form-control" v-model="settings['proxy.port']" :disabled="!isSettingSet(slotProps.rowFields)">
                </div>
                <div class="col-sm-3"></div>
                <div class="col-sm-2 control-label">
                  <p-checkbox @input="toggleSetOptions(slotProps.rowFields)" :checked="!isSettingSet(slotProps.rowFields)">{{ useDefaultLabel }}</p-checkbox>
                </div>
              </div>
            </template>
          </field-set>

          <field-set :row-fields="['webgrab.proxy.username', 'webgrab.proxy.password']">
            <template v-slot:default="slotProps">

              <div v-if="isSettingEnabled(slotProps.rowFields)">
                <label class="col-sm-2 control-label">Proxy credentials</label>
                <div class="col-sm-3 text-left">
                  <input type="text" placeholder="Username" class="form-control" v-model="settings['webgrab.proxy.username']" :disabled="!isSettingSet(slotProps.rowFields)">
                </div>
                <div class="col-sm-3 text-left">
                  <input type="password" placeholder="Password" class="form-control" v-model="settings['webgrab.proxy.password']" :disabled="!isSettingSet(slotProps.rowFields)">
                </div>
                <div class="col-sm-2"></div>
                <div class="col-sm-2 control-label">
                  <p-checkbox @input="toggleSetOptions(slotProps.rowFields)" :checked="!isSettingSet(slotProps.rowFields)">{{ useDefaultLabel }}</p-checkbox>
                </div>
              </div>
            </template>
          </field-set>

          <field-set :row-fields="['webgrab.user_agent']">
            <template v-slot:default="slotProps">

              <div v-if="isSettingEnabled(slotProps.rowFields)">
                <label class="col-sm-2 control-label">User-Agent</label>
                <div class="col-sm-6 text-left">
                  <textarea class="form-control" placeholder="Here can be your nice text" rows="3" :disabled="!isSettingSet(slotProps.rowFields)">{{ settings['webgrab.user_agent'] }}</textarea>
                </div>
                <div class="col-sm-2"></div>
                <div class="col-sm-2 control-label">
                  <p-checkbox @input="toggleSetOptions(slotProps.rowFields)" :checked="!isSettingSet(slotProps.rowFields)">{{ useDefaultLabel }}</p-checkbox>
                </div>
              </div>
            </template>
          </field-set>


          <field-set :row-fields="['webgrab.retry.channel_delay', 'webgrab.retry.index_delay', 'webgrab.retry.show_delay', 'webgrab.retry.time_out']">
            <template v-slot:default="slotProps">

              <div v-if="isSettingEnabled(slotProps.rowFields)">
                <label class="col-sm-2 control-label">Retry times</label>
                <div class="col-sm-2 text-left">
                  <input type="number" class="form-control" v-model="settings['webgrab.retry.channel_delay']" :disabled="!isSettingSet(slotProps.rowFields)">
                  <span class="help-block">delay between retries</span>
                </div>
                <div class="col-sm-2 text-left">
                  <input type="number" class="form-control" v-model="settings['webgrab.retry.index_delay']" :disabled="!isSettingSet(slotProps.rowFields)">
                  <span class="help-block">dellay between grabbing of subsequent channels</span>
                </div>
                <div class="col-sm-2 text-left">
                  <input type="number" class="form-control" v-model="settings['webgrab.retry.show_delay']" :disabled="!isSettingSet(slotProps.rowFields)">
                  <span class="help-block">delay between grabbing of index pages</span>
                </div>
                <div class="col-sm-2 text-left">
                  <input type="number" class="form-control" v-model="settings['webgrab.retry.time_out']" :disabled="!isSettingSet(slotProps.rowFields)">
                  <span class="help-block">delay between grabbing of detail show pages</span>
                </div>
                <div class="col-sm-2 control-label">
                  <p-checkbox @input="toggleSetOptions(slotProps.rowFields)" :checked="!isSettingSet(slotProps.rowFields)">{{ useDefaultLabel }}</p-checkbox>
                </div>
              </div>
            </template>
          </field-set>

          <field-set :row-fields="['webgrab.skip.h','webgrab.skip.m']">
            <template v-slot:default="slotProps">

              <div v-if="isSettingEnabled(slotProps.rowFields)">
                <label class="col-sm-2 control-label">Skip</label>
                <div class="col-sm-2 text-left">
                  <input type="text" class="form-control" v-model="settings['webgrab.skip.h']" :disabled="!isSettingSet(slotProps.rowFields)">
                  <span class="help-block">max. number of hours a show can be before it is skipped</span>
                </div>
                <div class="col-sm-2 text-left">
                  <input type="text" class="form-control" v-model="settings['webgrab.skip.m']" :disabled="!isSettingSet(slotProps.rowFields)">
                  <span class="help-block">min. number of minutes a show should be before it is skipped</span>
                </div>
                <div class="col-sm-4"></div>
                <div class="col-sm-2 control-label">
                  <p-checkbox @input="toggleSetOptions(slotProps.rowFields)" :checked="!isSettingSet(slotProps.rowFields)">{{ useDefaultLabel }}</p-checkbox>
                </div>
              </div>
            </template>
          </field-set>

          <field-set :row-fields="['webgrab.timespan']">
            <template v-slot:default="slotProps">

              <div v-if="isSettingEnabled(slotProps.rowFields)">
                <label class="col-sm-2 control-label">Timespan</label>
                <div class="col-sm-8 text-left">
                  <input type="text" class="form-control" v-model="settings['webgrab.timespan']" :disabled="!isSettingSet(slotProps.rowFields)">
                  <span class="help-block">
                    The timespan for which shows will be grabbed. It takes one or two values separated by a comma or a space. The first is the number of days (including today) to download, note that 0 is today. The second (optional) is a time specified between 0:00 and 24:00 which will reduce the download to only the one show (per day) which is scheduled around the specified time. Any value between start time (including) and stop time will do. This -one-show-only mode is helpfull if a SiteIni file needs to be debugged.
                  </span>
                </div>
                <div class="col-sm-2 control-label">
                  <p-checkbox @input="toggleSetOptions(slotProps.rowFields)" :checked="!isSettingSet(slotProps.rowFields)">{{ useDefaultLabel }}</p-checkbox>
                </div>
              </div>
            </template>
          </field-set>
        </v-tab>


        <v-tab title="MDB" v-if="isGroupEnabled('MDB')">
          <field-set :row-fields="['mdb.xml']">
            <template v-slot:default="slotProps">

              <div v-if="isSettingEnabled(slotProps.rowFields)">
                <div class="col-sm-10">
                  <prism-editor class="my-editor" v-model="settings['mdb.xml']" :highlight="highlighter" line-numbers :readonly="!isSettingSet(slotProps.rowFields)"></prism-editor>
                </div>
                <div class="col-sm-2 control-label">
                  <p-checkbox @input="toggleSetOptions(slotProps.rowFields)" :checked="!isSettingSet(slotProps.rowFields)">{{ useDefaultLabel }}</p-checkbox>
                </div>
              </div>
            </template>
          </field-set>
        </v-tab>


        <v-tab title="REX" v-if="isGroupEnabled('REX')">
          <field-set :row-fields="['rex.xml']">
            <template v-slot:default="slotProps">

              <div v-if="isSettingEnabled(slotProps.rowFields)">
                <div class="col-sm-10">
                  <prism-editor class="my-editor" v-model="settings['rex.xml']" :highlight="highlighter" line-numbers :readonly="!isSettingSet(slotProps.rowFields)"></prism-editor>
                </div>
                <div class="col-sm-2 control-label">
                  <p-checkbox @input="toggleSetOptions(slotProps.rowFields)" :checked="!isSettingSet(slotProps.rowFields)">{{ useDefaultLabel }}</p-checkbox>
                </div>
              </div>
            </template>
          </field-set>
        </v-tab>
      </vue-tabs>
      <div class="text-center">
        <button class="btn btn-lg btn-fill btn-info" @click.prevent="saveSettings()">Save settings</button>
      </div>
    </form>
  </div>
</template>
<script>
import Vue from 'vue'
import VueTabs from 'vue-nav-tabs'
import {TimeSelect, Slider} from 'element-ui'

import {PrismEditor} from 'vue-prism-editor';
import 'vue-prism-editor/dist/prismeditor.min.css';

import {highlight, languages} from 'prismjs/components/prism-core';
import 'prismjs/components/prism-markup';
import 'prismjs/themes/prism-tomorrow.css';

import {mapActions, mapGetters} from 'vuex'
import FieldSet from "./SettingsForm/FieldSet";

Vue.use(VueTabs)
export default {
  components: {
    FieldSet,
    [TimeSelect.name]: TimeSelect,
    [Slider.name]: Slider,
    PrismEditor
  },
  props: {
    disabledSettings: {
      type: Array,
      default: () => []
    },
    disabledGroups: {
      type: Array,
      default: () => []
    },
    scope: {
      type: String,
      default: 'global'
    },
    scope_id: {
      type: String,
      default: null
    }
  },
  async mounted () {
    Vue.nextTick(async () => {
      await this.settingsFetchByScope({scope: this.scope, scope_id: this.scope_id});
      if (!this.getSettingsByScope(this.scope, this.scope_id)) {
        await this.settingsCreate({scope: this.scope, scope_id: this.scope_id});
      }
      this.updateFormData();
    });
  },
  computed: {
    ...mapGetters(['getSettingsByScope']),
    useDefaultLabel: function () {
      return this.scope === 'server' ? 'Use global' : 'Use default';
    }
  },
  data () {
    return {
      settings: {},
      optionsSet: []
    }
  },
  methods: {
    ...mapActions(['settingsCreate', 'settingsUpdate', 'settingsFetchByScope']),
    updateFormData: function () {
      const settings = this.getSettingsByScope(this.scope, this.scope_id);
      if (settings) {
        if (settings.data_scoped) {
          this.settings = JSON.parse(settings.data_scoped);
        }
        if (settings.data_filled) {
          this.optionsSet = settings.data_filled;
        }
      }
    },
    isGroupEnabled: function (groupName) {
      return !this.disabledGroups.includes(groupName)
    },
    isSettingEnabled: function (settings) {
      let isset = true;
      if (!Array.isArray(settings)) {
        settings = [settings];
      }
      settings.forEach((settingName) => {
        isset = isset && !this.disabledSettings.includes(settingName)
      });
      return isset;
    },
    isSettingSet: function (settings) {
      let isset = false;
      if (!Array.isArray(settings)) {
        settings = [settings];
      }
      settings.forEach((settingName) => {
        isset = isset || this.optionsSet.includes(settingName)
      });
      return isset;
    },
    toggleSetOptions: function (options) {
      if (this.isSettingSet(options)) {
        this.optionsSet = this.optionsSet.filter(option => !options.includes(option))
      } else {
        this.optionsSet = [...new Set([...this.optionsSet, ...options])];
      }
    },
    saveSettings: async function () {
      const model = this.getSettingsByScope(this.scope, this.scope_id);
      let changedSettings = {};
      console.log(this.optionsSet);
      this.optionsSet.forEach((option) => {
        console.log(option, this.settings[option])
        if (this.settings[option]) {
          changedSettings[option] = this.settings[option];
        }
      });
      console.log('changedSettings', changedSettings);
      await this.settingsUpdate({id: model.id, data: JSON.stringify(changedSettings)});
      this.updateFormData();
    },
    highlighter (code) {
      return highlight(code, languages.xml); // languages.<insert language> to return html with markup
    },
  }
}
</script>
<style>
.height-200 {
  height: 200px
}

.my-editor {
  /* we dont use `language-` classes anymore so thats why we need to add background and text color manually */
  background: #2d2d2d;
  color: #ccc;

  /* you must provide font-family font-size line-height. Example:*/
  font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
  font-size: 14px;
  line-height: 1.5;
  padding: 5px;
}

.my-editor pre {
  color: #ccc;
}

/* optional class for removing the outline */
.prism-editor__textarea:focus {
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Partials/SettingsForm.vue